/**
 * @generated SignedSource<<97670ad1a97ab5369031f99cab2b59d3>>
 * @relayHash 647398da5f046eab487178776f59ec6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 29ca9ec3b6d7be7170e2da0e8662dc06bfdaf4762282d10e71dbefcbed8ec3ee

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useViewPermissionsModalPermissionsQuery$variables = Record<PropertyKey, never>;
export type useViewPermissionsModalPermissionsQuery$data = {
  readonly spacePermissionsAll: {
    readonly nodes: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly displayName: string;
      readonly group: {
        readonly displayName: string;
        readonly priority: number;
      };
      readonly hubDescription: string | null | undefined;
      readonly hubDisplayName: string | null | undefined;
      readonly id: string;
      readonly priority: number;
      readonly requiredSpacePermissions: ReadonlyArray<string | null | undefined> | null | undefined;
    }>;
  } | null | undefined;
};
export type useViewPermissionsModalPermissionsQuery = {
  response: useViewPermissionsModalPermissionsQuery$data;
  variables: useViewPermissionsModalPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v1 = {
  "kind": "ScalarField",
  "name": "priority"
},
v2 = [
  {
    "concreteType": "SpacePermissionConnection",
    "kind": "LinkedField",
    "name": "spacePermissionsAll",
    "plural": false,
    "selections": [
      {
        "concreteType": "SpacePermissionInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "hubDisplayName"
          },
          {
            "kind": "ScalarField",
            "name": "hubDescription"
          },
          (v1/*: any*/),
          {
            "concreteType": "SpacePermissionGroup",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "requiredSpacePermissions"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewPermissionsModalPermissionsQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useViewPermissionsModalPermissionsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "647398da5f046eab487178776f59ec6d",
    "id": "29ca9ec3b6d7be7170e2da0e8662dc06bfdaf4762282d10e71dbefcbed8ec3ee",
    "metadata": {},
    "name": "useViewPermissionsModalPermissionsQuery",
    "operationKind": "query",
    "text": "query useViewPermissionsModalPermissionsQuery{spacePermissionsAll{nodes{id,displayName,description,hubDisplayName,hubDescription,priority,group{displayName,priority},requiredSpacePermissions}}}"
  }
};
})();

(node as any).hash = "e4a3c349162ebabf09288d398062a645";

export default node;
